import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { EventEnum } from 'src/app/entrance/types';
import { CodebookService } from 'src/services/codebook.service';
import { fileCheck } from 'src/app/utils/fileInputUtil';
import { CaseService } from 'src/services/case.service';
import { ExpeditionService } from 'src/services/expedition.service';
import { DataSharingService } from 'src/services/data-sharing.service';

@Component({
    selector: 'app-complain-decision',
    templateUrl: './complain-decision.component.html',
    styleUrls: ['./complain-decision.component.scss']
})
export class ComplainDecisionComponent implements OnInit {

    complainResponses: any = [];
    @ViewChild('documentInput') documentInput: ElementRef<HTMLInputElement>;
    disableDocumentUpload = true;
    allowConfirmWithoutDocument = false;
    fileToUpload: File = null;
    isSending = false;
    msWordUsed = false;
    subjectId: number;
    caseId: number;
    caseName: string;
    caseType: string;

    constructor(
        private formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<ComplainDecisionComponent>,
        public dialog: MatDialog,
        private translate: TranslateService,
        private codebookService: CodebookService,
        private caseService: CaseService,
        private expedition: ExpeditionService,
        private dataSharingService: DataSharingService,
        @Inject(MAT_DIALOG_DATA) public data: { subjectId: number; caseId: number; caseName: string; caseType?: string }
    ) { }
    complainDecisionForm: FormGroup;

    ngOnInit(): void {
        this.codebookService.getComplainResponseCodebook().subscribe(response => {
            this.complainResponses = response;
        });
        this.complainDecisionForm = this.formBuilder.group({
            decision: ['', [Validators.required]],
            lawyerFile: [null],
            fileName: [{ value: '', disabled: true }],
        });
        this.subjectId = this.data?.subjectId;
        this.caseId = this.data?.caseId;
        this.caseName = this.data?.caseName;
        this.caseType = this.data?.caseType || 'complain';
    }

    makeDecision(complainDecisionForm: FormGroup) {
        this.dialogRef.close({ event: EventEnum.SUBMIT, data: this.complainDecisionForm.controls.decision.value });

    }

    closeDialog() {
        this.dialogRef.close({ event: 'Cancel' });
    }
    
    radioChange(event: any) {
        this.complainDecisionForm.controls.decision.setValue(event);
        this.disableDocumentUpload = event?.id === 2 || event?.id === 3;
        this.allowConfirmWithoutDocument = this.disableDocumentUpload;
        this.resetDocumentSelection();

        const fileNameControl = this.complainDecisionForm.get('fileName');
        if (!this.disableDocumentUpload) {
            fileNameControl.enable();
            fileNameControl.setValidators(Validators.required);
        } else {
            fileNameControl.disable();
            fileNameControl.clearValidators();
            fileNameControl.setValue('');
            this.complainDecisionForm.get('lawyerFile').setValue(null);
        }
        fileNameControl.updateValueAndValidity();
    }

    resetDocumentSelection() {
        this.fileToUpload = null;
        this.complainDecisionForm.get('lawyerFile').setValue(null);
        this.complainDecisionForm.get('fileName').setValue('');
        if (this.documentInput) {
            this.documentInput.nativeElement.value = '';
        }
    }

    handleFileInput(files: FileList) {
        const modifiedFiles = fileCheck(files, this.dialog, this.translate);
        if (!modifiedFiles || modifiedFiles.length === 0) {
            this.resetDocumentSelection();
            return;
        }
        this.fileToUpload = modifiedFiles[0];
        this.complainDecisionForm.get('lawyerFile').setValue(this.fileToUpload);
        this.complainDecisionForm.get('fileName').setValue(this.fileToUpload.name);
        if (this.documentInput) {
            this.documentInput.nativeElement.value = '';
        }
    }

    shouldDisableConfirm(): boolean {
        const selectedDecision = this.complainDecisionForm?.controls?.decision.value;
        if (!selectedDecision) {
            return true;
        }
        return selectedDecision.id === 1;
    }

    canTriggerDocumentUpload(): boolean {
        return this.complainDecisionForm.controls.decision.valid && !this.disableDocumentUpload;
    }

    isSendDisabled(): boolean {
        
        if (this.disableDocumentUpload) {
            return true;
        }
        if (!this.subjectId || !this.caseId) {
            return true;
        }
        return this.isSending || !this.complainDecisionForm.get('fileName').value;
    }

    sendRequest() {
        this.isSending = true;
        this.caseService.finishCase(
            this.msWordUsed,
            this.complainDecisionForm.get('lawyerFile').value,
            this.complainDecisionForm.get('fileName').value,
            this.subjectId,
            this.caseId,
            this.caseName,
            this.caseType,
            this.expedition,
            this.dataSharingService,
            () => this.handleFinishError()
        );
    }

    private handleFinishError() {
        this.isSending = false;
    }

}
